import React from 'react';
import classnames from 'classnames';

import './Picture.scss';

export interface PictureProps {
    /**
     * Path or URL image default
     */
    src: string;
    /**
     * Small size
     */
    small?: string;
    /**
     * Medium size
     */
    medium?: string;
    /**
     * Large size
     */
    large?: string;
    /**
     * X Large size
     */
    xLarge?: string;
    /**
     * alt text for in image
     */
    alt?: any;
    /**
     * Width image
     */
    width?: string | number;
    /**
     * Height image
     */
    height?: string | number;
    /**
     * Rounded border
     */
    rounded?: boolean;
    /**
     * Shadow image
     */
    shadow?: boolean;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on load image
     */
    onLoad?(): any;
}

const Picture: React.FC<PictureProps> = ({
    src = '',
    small = '',
    medium = '',
    large = '',
    xLarge = '',
    alt = '',
    width,
    height,
    shadow = false,
    rounded = false,
    className,
    style,
    onLoad = () => {},
}) => {
    const classNames = classnames(['picture', { shadow, rounded }, className]);
    const srcDefault = small || src;
    const srcSet = [
        ...(small ? [`${small} 576w`] : []),
        ...(medium ? [`${medium} 768w`] : []),
        ...(large ? [`${large} 992w`] : []),
        ...(xLarge ? [`${xLarge} 1200w`] : []),
    ].join(',');

    return (
        <img
            className={classNames}
            style={style}
            src={srcDefault}
            {...(srcSet ? { srcSet } : {})}
            alt={alt}
            width={width}
            height={height}
            onLoad={onLoad}
        />
    );
};

export default Picture;
